import { useEffect, useRef, useState } from "react";
import { BiExpandAlt } from "react-icons/bi";

import { useTheme } from "../../../../context/ThemeContext";
import Button from "../../../Button";

const Output = ({ output, isHorizontal }) => {
  const { theme } = useTheme();
  const outputRef = useRef(null);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [isFullScreen, setIsFullScreen] = useState(false);

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        setDimensions({
          width: entry.contentRect.width,
          height: entry.contentRect.height,
        });
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);
    if (outputRef.current) {
      resizeObserver.observe(outputRef.current);
    }

    return () => {
      if (outputRef.current) {
        resizeObserver.unobserve(outputRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleFullScreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullScreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullScreenChange);
    };
  }, []);

  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      outputRef.current?.requestFullscreen().catch((err) => {
        alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <div
      ref={outputRef}
      className={`w-full ${isHorizontal ? "h-[67vh] lg:w-1/2" : ""} relative rounded-lg border border-gray-50 bg-white p-1 shadow-md dark:border-dark-border dark:bg-[#1e272e]`}
    >
      <div className="mb-2 flex justify-between">
        <div className="mt-2 text-sm text-gray-700 dark:text-gray-100">
          <span className="mx-2">Result Size: {Math.round(dimensions.width)}</span>
          <span>x {Math.round(dimensions.height)}</span>
        </div>
      </div>
      <iframe
        srcDoc={`
    <html>
      <head>
        <style>
          body { background-color: ${theme === "dark" ? "#1e272e" : "white"}; color: ${theme === "dark" ? "white" : "black"}; }
        </style>
      </head>
      <body>
        ${output}
      </body>
    </html>
  `}
        className={`${isFullScreen ? "h-[89vh]" : isHorizontal ? "h-[55vh]" : "h-[25vh]"} w-full`}
      />

      <Button
        icon={<BiExpandAlt size={20} />}
        className="absolute bottom-4 right-4 z-20 rounded-lg bg-blue-500 p-2 text-white shadow-md hover:bg-blue-600"
        onClick={toggleFullScreen}
      />
    </div>
  );
};

export default Output;
